import { render, staticRenderFns } from "./VModalGeneral.vue?vue&type=template&id=4ae24076&"
import script from "./VModalGeneral.vue?vue&type=script&lang=ts&"
export * from "./VModalGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./VModalGeneral.vue?vue&type=style&index=0&id=4ae24076&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports